import updateTargetings from './update-targetings';
import { IMAGE } from '../../constants';
import { PB_TYPE_BANNER } from './constants';

const checkCollision = (typeToCheck, currentType) => {
  if (currentType === IMAGE) return true;
  return typeToCheck === IMAGE;
};

const injectElementComponents = (componentsToInject, children) => {
  if (!componentsToInject.length) return children;
  const updatedChildren = [];

  componentsToInject.forEach(componentToInject => {
    const {
      type: componentsToInjectType,
      settings: { repeatEvery, startingPoint, maxRepetitions }
    } = componentToInject;

    let repetitionTotal = 0;
    let currentPosition = startingPoint;

    children.forEach((child, i) => {
      const isComponentMatch = componentToInject.name !== child.name;
      const { type } = child;
      const { type: previousComponentType } = children[i - 1] || {};
      const { type: nextComponentType } = children[i + 1] || {};
      const collidedBefore = checkCollision(previousComponentType, type);
      const collidedAfter = checkCollision(nextComponentType, type);

      if (collidedBefore || (i === 0 && collidedAfter)) {
        if (currentPosition <= i) currentPosition += 1;
        if (isComponentMatch) updatedChildren.push(child);
        return;
      }

      const hasReachedMax = maxRepetitions && repetitionTotal >= maxRepetitions;
      if (!hasReachedMax && i === currentPosition) {
        const updatedComponentToInject =
          repeatEvery && componentsToInjectType === PB_TYPE_BANNER
            ? updateTargetings(componentToInject, repetitionTotal)
            : componentToInject;
        const updatedSettings = { ...updatedComponentToInject.settings };
        updatedChildren.push({ ...updatedComponentToInject, settings: updatedSettings });
        repetitionTotal += 1;
        currentPosition += repeatEvery;
      }

      if (isComponentMatch) updatedChildren.push(child);
    });
  });

  return updatedChildren;
};

export default injectElementComponents;
